import { Capacitor } from '@capacitor/core';

export type PushDevicePlatform = 'ios' | 'android' | 'web';

export function getPushDevicePlatform(): PushDevicePlatform {
  const p = Capacitor.getPlatform();
  if (p === 'ios' || p === 'android') {
    return p;
  }
  return 'web';
}
